import React, { useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import AbsencePlannerDrawer from 'components/AbsencePlannerDrawer'
import CommentModal from 'redesign/components/organisms/comment-modal'
import TimelineActionDialog from 'redesign/components/organisms/timeline-action-dialog'
import TimelineActionContext from './context'
import type {
  AbsencePlannerDrawerProps,
  DialogProps,
  MessageDrawerProps,
  TimelineActionButtonProviderProps,
} from './types'

const TimelineActionButtonProvider: React.FC<TimelineActionButtonProviderProps> = ({ children, rootId }) => {
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const [messageDrawerProps, setMessageDrawerProps] = useState<MessageDrawerProps | undefined>()
  const [dialogProps, setDialogProps] = useState<DialogProps | undefined>()
  const [absencePlannerDrawerProps, setAbsencePlannerDrawerProps] = useState<AbsencePlannerDrawerProps | undefined>()
  const [isBalanceDrawerOpen, setIsBalanceDrawerOpen] = useState(false)

  return (
    <TimelineActionContext.Provider
      value={{
        messageDrawerProps,
        setMessageDrawerProps,
        dialogProps,
        setDialogProps,
        isBalanceDrawerOpen,
        setIsBalanceDrawerOpen,
        setAbsencePlannerDrawerProps,
      }}
    >
      <CommentModal
        isOpen={Boolean(messageDrawerProps)}
        onClose={() => setMessageDrawerProps(undefined)}
        {...messageDrawerProps}
        isSmallScreen={isSmallScreen}
        closeAfterAction
        rootId={rootId}
      />

      {dialogProps && (
        <TimelineActionDialog
          isOpen={Boolean(dialogProps)}
          onClose={() => setDialogProps(undefined)}
          {...dialogProps}
        />
      )}

      <AbsencePlannerDrawer
        isOpen={Boolean(absencePlannerDrawerProps)}
        onCancel={() => setAbsencePlannerDrawerProps(undefined)}
        startDate={absencePlannerDrawerProps?.startDate ?? ''}
        endDate={absencePlannerDrawerProps?.endDate ?? ''}
        previewPerson={absencePlannerDrawerProps?.previewPerson}
      />

      {children}
    </TimelineActionContext.Provider>
  )
}

export default TimelineActionButtonProvider
